// frontend/src/utils/partyLogoMap.js

const partyLogoMap = {
    "Bharatiya Janata Party": "/party-logos/bjp.png",
    "Indian National Congress": "/party-logos/congress.png",
    "Janata Dal (United)": "/party-logos/Jdu.png",
    "Rashtriya Janata Dal": "/party-logos/rjd.png",
    "Communist Party of India (Marxist)": "/party-logos/cpim.png",
    "Communist Party of India": "/party-logos/party.png",
    "Aam Aadmi Party": "/party-logos/aap.png",
    "Lok Janshakti Party": "/party-logos/party.png",
    "Samajwadi Party": "/party-logos/party.png",
    "Bahujan Samaj Party": "/party-logos/party.png",
    "All India Trinamool Congress": "/party-logos/party.png",
    "Nationalist Congress Party": "/party-logos/party.png",
    "Shiromani Akali Dal": "/party-logos/party.png",
    // Add more parties as needed
  };
  
  export default partyLogoMap;  
